








import { Vue, Component, Prop } from "vue-property-decorator";
import AltLogoFull from "./alt-logo-full.vue";
import AltLogoMin from "./alt-logo-min.vue";
import UposLogoFull from "./upos-logo-full.vue";
import UposLogoMin from "./upos-logo-min.vue";

@Component({
    name: "alt-logo",
    components: {
        AltLogoFull,
        AltLogoMin,
        UposLogoFull,
        UposLogoMin,
    },
})
export default class AltLogo extends Vue {
    @Prop({ type: String, default: "none" })
    private integrator!: string;

    @Prop({ type: Boolean, default: false })
    private full!: boolean;

    @Prop({ type: String, default: "fil2" })
    private classSubTitle!: string;
}
